import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamicHost]',
})

export class DynamicHostDirective {

    public constructor(public viewContainerRef: ViewContainerRef) {

        let s: string = "";
    }
}
